import { useEffect, useState } from 'react';
import { omit, debounce } from '../../../utils';
import * as tracker from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import AdminOnlyWrapper from 'ui-addon-upgrades/_core/common/components/AdminOnlyWrapper';
import { TEAM } from 'ui-addon-upgrades/_core/common/constants/AdminTypes';
import { REQUEST_TRIAL } from 'ui-addon-upgrades/_core/common/constants/AdminModalTypes';
import TrialActivationModalContainer from './TrialActivationModalContainer';
import { getUpgradeDataTrackingProperties } from 'ui-addon-upgrades/ums/utils';
import TrialActivationButtonWithTooltip from './TrialActivationButtonWithTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CLICK_DELAY = 50;
function sequence(...handlers) {
  return (...args) => {
    handlers.forEach(handler => handler && handler(...args));
  };
}
const TrialActivationButton = props => {
  const [showActivationModalContainer, setShowActivationModalContainer] = useState(false);
  const {
    activeTrials,
    expiredTrials,
    hideBackground,
    isMultiTrial,
    upgradeData,
    level,
    isUpgradePoint,
    onClick = () => {},
    onSuccess,
    shouldHideSurvey,
    successModalHeader,
    successModalSubText,
    successModalCtaText,
    showSuccessModalIllustration,
    children,
    canViewNewSeats,
    isTX0120Variant = false,
    isTX0120Fetched = false,
    isEligibleForTX0120 = false,
    isUpgradeModal = false,
    isLoadingTrackingProps,
    use = 'primary'
  } = props;
  const handleClick = () => {
    tracker.track('trialActivationButtonInteraction', Object.assign({
      action: 'clicked'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      isMultiTrial,
      activeTrials,
      expiredTrials,
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));
    if (isUpgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'clicked upgrade point'
      }, getUpgradeDataTrackingProperties(upgradeData)));
      tracker.track('interaction', Object.assign({
        action: 'clicked trial activation',
        isPrimaryCta: level === 1,
        isSecondaryCta: level === 2
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
    setShowActivationModalContainer(true);
  };
  const debouncedHandleClick = debounce(handleClick, CLICK_DELAY);
  useEffect(() => {
    tracker.track('trialActivationButtonInteraction', Object.assign({
      action: 'viewed'
    }, getUpgradeDataTrackingProperties(upgradeData), {
      isMultiTrial,
      activeTrials,
      expiredTrials,
      trialId: upgradeData.trialId,
      duration: upgradeData.duration
    }));
    if (isUpgradePoint) {
      tracker.track('interaction', Object.assign({
        action: 'viewed trial activation',
        isPrimaryCta: level === 1,
        isSecondaryCta: level === 2
      }, getUpgradeDataTrackingProperties(upgradeData)));
    }
    return () => {
      debouncedHandleClick.reset();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const trialI18nKey = canViewNewSeats && upgradeData.apiName ? `upgrades.trialActivationButton.${upgradeData.apiName}` : `upgrades.trialActivationButton.${upgradeData.upgradeProduct}`;
  const isTrialed = !!activeTrials && activeTrials.includes(upgradeData.upgradeProduct);
  const onClickSequence = sequence(debouncedHandleClick, onClick);
  const propsToPass = omit(props, ['onClick', 'upgradeData', 'onSuccess', 'shouldHideSurvey', 'trialId', 'allowModal', 'successModalHeader', 'successModalSubText', 'successModalCtaText', 'showSuccessModalIllustration', 'isMultiTrial', 'activeTrials', 'expiredTrials', 'isUpgradePoint', 'hideBackground', 'canViewNewSeats', 'isTX0120Variant', 'isTX0120Fetched', 'isEligibleForTX0120', 'isUpgradeModal', 'isLoadingTrackingProps']);
  const isLoading = isEligibleForTX0120 && !isTX0120Fetched || !!isLoadingTrackingProps;
  if (!upgradeData.trialId) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showActivationModalContainer && /*#__PURE__*/_jsx(TrialActivationModalContainer, {
      activeTrials: activeTrials,
      expiredTrials: expiredTrials,
      hideBackground: hideBackground,
      isMultiTrial: isMultiTrial,
      upgradeData: upgradeData,
      shouldHideSurvey: shouldHideSurvey,
      onSuccess: onSuccess,
      successModalHeader: successModalHeader,
      successModalSubText: successModalSubText,
      successModalCtaText: successModalCtaText,
      showSuccessModalIllustration: showSuccessModalIllustration,
      canViewNewSeats: canViewNewSeats,
      isTX0120Variant: isTX0120Variant,
      isTX0120Fetched: isTX0120Fetched,
      isEligibleForTX0120: isEligibleForTX0120,
      isUpgradeModal: isUpgradeModal
    }), /*#__PURE__*/_jsx(AdminOnlyWrapper, {
      upgradeData: upgradeData,
      adminType: TEAM,
      modalType: REQUEST_TRIAL,
      canViewNewSeats: canViewNewSeats,
      children: /*#__PURE__*/_jsx(TrialActivationButtonWithTooltip, {
        upgradeProduct: upgradeData.upgradeProduct,
        onClick: onClickSequence,
        isTrialed: isTrialed,
        isLoading: isLoading,
        trialI18nKey: trialI18nKey,
        showActivationModalContainer: showActivationModalContainer,
        propsToPass: propsToPass,
        use: use,
        children: children
      })
    })]
  });
};
export default TrialActivationButton;